import React from "react";

// Zenko Orbit Flujo logo: concentric arcs + central dot + flowing orbit
const ZenkoLogo = ({ size = 40, animated = true, className = "" }) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 64 64"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      aria-label="Zenko logo"
    >
      <defs>
        <linearGradient id="zkGrad" x1="0%" y1="0%" x2="100%" y2="100%">
          <stop offset="0%" stopColor="#00E5A0" />
          <stop offset="60%" stopColor="#00E5A0" stopOpacity="0.4" />
          <stop offset="100%" stopColor="#00E5A0" stopOpacity="0" />
        </linearGradient>
        <linearGradient id="zkGrad2" x1="100%" y1="0%" x2="0%" y2="100%">
          <stop offset="0%" stopColor="#7CFFD0" />
          <stop offset="100%" stopColor="#00E5A0" stopOpacity="0.2" />
        </linearGradient>
      </defs>
      {/* Outer thin ring */}
      <circle cx="32" cy="32" r="28" stroke="#1B2D44" strokeWidth="1.5" />
      {/* Animated orbit arc */}
      <g className={animated ? "animate-orbit-slow" : ""} style={{ transformOrigin: "32px 32px" }}>
        <path d="M 32 4 A 28 28 0 0 1 60 32" stroke="url(#zkGrad)" strokeWidth="3" strokeLinecap="round" fill="none" />
      </g>
      {/* Mid ring */}
      <circle cx="32" cy="32" r="20" stroke="#2A3A4F" strokeWidth="1" />
      <g className={animated ? "animate-orbit-mid" : ""} style={{ transformOrigin: "32px 32px" }}>
        <path d="M 12 32 A 20 20 0 0 1 32 12" stroke="url(#zkGrad2)" strokeWidth="2.5" strokeLinecap="round" fill="none" />
      </g>
      {/* Inner glow */}
      <circle cx="32" cy="32" r="10" fill="#00E5A0" fillOpacity="0.08" />
      <circle cx="32" cy="32" r="6" fill="#00E5A0" fillOpacity="0.18" />
      {/* Core dot */}
      <circle cx="32" cy="32" r="3" fill="#00E5A0" />
      {/* Orbiting particle */}
      <g className={animated ? "animate-orbit-fast" : ""} style={{ transformOrigin: "32px 32px" }}>
        <circle cx="60" cy="32" r="2" fill="#7CFFD0" />
      </g>
    </svg>
  );
};

export default ZenkoLogo;
